require('./openYoungCardChoresView.scss');
// @vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');
const { isEmpty } = require('lodash');

// @commons
const { formatText, FormattedText, getFinalTitle, getLanguage } = require('core/i18n').i18n;
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { LastMovementsTable } = require('commonsComponents/lastMovementsTable');
const { ChoreListTableRow } = require('./components/choreListTableRow/choreListTableRow');
const OpenYoungCardChoresFilter = require('./components/openYoungCardChoresFilter/openYoungCardChoresFilter');
const { LoadingSection } = require('commonsComponents/loadingSection');
const TutorialLauncher = require('components/tutorial/tutorialLauncher');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { ChoreListTableInfoRow } = require('./components/choreListTableInfoRow/choreListTableInfoRow');
const { EmptyState } = require('commonsComponents/emptyState');
const { LabelFilterRange } = require('commonsComponents/labelFilterRange');
const { ClearAllFiltersButton } = require('commonsComponents/clearAllFiltersButton');
const { countActiveFilters } = require('utilities/filtersHelper');

// @constants
const { GRAPHIC_TUTOR_TYPE_4 } = require('constants/index');
const { LAST_MOVEMENTS_TABLE_CURRENT_MONTH_KEY, DATE_PICKER_CUSTOM_DATE_FORMAT, CLEAR_ALL_FILTERS_BUTTON_LABEL } = require('constants/commonsComponents');
const { choresStatus } = require('constants/openYoungCardChores');

// @ actions
const openYoungCardChores = require('actions/openYoungCardChores');

const language = getLanguage();
class OpenYoungCardChoresView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            filterSettingsOpen: false
        }

        this.handleCreateChore = this.handleCreateChore.bind(this);
        this.handleRowClick = this.handleRowClick.bind(this);
        this.loadChoreList = this.loadChoreList.bind(this);
        this.handleRetry = this.handleRetry.bind(this);
        this.handleSetFilter = this.handleSetFilter.bind(this);
        this.handleClearFilters = this.handleClearFilters.bind(this);
        this.handleResetFilter = this.handleResetFilter.bind(this);
        this.handleToggleFilters = this.handleToggleFilters.bind(this);

        this.state = {
            expandedRowId: '',
        }
    }

    componentWillMount() {
        const { immCards, match: { params: { cardId } } } = this.props;
        const immCard = immCards.getIn(['byId', cardId]);

        this.props.getChoreList(immCard);
    }

    componentWillUnmount() {
        this.props.clearFilters();
    }

    handleCreateChore() {
        const { match: { params: { cardId } }, history } = this.props;
        history.push(`/myprofile/cards/${cardId}/chores/create-chore`);
    }

    handleClearFilters() {
        this.props.clearFilters();
        this.handleRetry();
    }

    handleResetFilter(filter) {
        this.props.resetFilter(filter);
        this.handleRetry();
    }

    handleRowClick(rowId) {
        this.setState({
            expandedRowId: rowId === this.state.expandedRowId ? '' : rowId
        });
    }

    handleRetry() {
        const { immCards, match: { params: { cardId } } } = this.props;
        const immCard = immCards.getIn(['byId', cardId]);

        this.props.getChoreList(immCard);
    }

    handleSetFilter(filters) {
        this.props.setFilter(filters);
        this.handleRetry();
    }

    handleToggleFilters() {
        this.setState({
            filterSettingsOpen: !this.state.filterSettingsOpen
        })
    }

    getStatus(key) {
        return choresStatus().filter(
            statusObj => statusObj.key === key
        )[0];
    }

    buildDateFilterLabel() {
        const { openYoungCardChores } = this.props;
        const immFilter = openYoungCardChores.get('filters');
        const immFilterDate = immFilter.get('date');
        const language = getLanguage();
        const labelFromDate = immFilterDate.get('from').locale(language).format(formatText(DATE_PICKER_CUSTOM_DATE_FORMAT));
        const labelToDate = immFilterDate.get('to').locale(language).format(formatText(DATE_PICKER_CUSTOM_DATE_FORMAT));

        return (
            <LabelFilterRange
                key="filter-date"
                from={labelFromDate}
                to={labelToDate}
                closeCallback={() => this.handleResetFilter('date')}
            />
        );
    }

    buildStatusFilterLabel() {
        const { openYoungCardChores } = this.props;
        const immFilter = openYoungCardChores.get('filters');
        const immFilterStatus = immFilter.get('status');
        if (immFilterStatus.get('isActive')) {
            const selectedStatus = formatText(`openYoungCardChores-status${immFilterStatus.get('status')}`);
            const statusLabel = formatText('openYoungChoresFilter-statusLabel', [selectedStatus]);
            return (
                <LabelFilterRange
                    from={statusLabel}
                    closeCallback={() => this.handleResetFilter('status')}
                />
            );
        }
    }

    buildClearAllFilters() {
        const { openYoungCardChores } = this.props;
        const immFilter = openYoungCardChores.get('filters');
        let labelElement;
        if (countActiveFilters(immFilter) > 1) {
            labelElement = (
                <ClearAllFiltersButton label={CLEAR_ALL_FILTERS_BUTTON_LABEL} onClick={this.handleClearFilters} />
            );
        }
        return labelElement;
    }

    displayAppliedFilters() {
        const { openYoungCardChores } = this.props;
        const immFilter = openYoungCardChores.get('filters');
        const immFilterStatus = immFilter.get('status');
        const immFilterDate = immFilter.get('date');
        const filterStatusLabel = immFilterStatus.get('isActive') ? this.buildStatusFilterLabel() : '';
        const filterDateLabel = immFilterDate.get('isActive') ? this.buildDateFilterLabel() : '';
        const clearAllFilters = this.buildClearAllFilters();
        return(
            <div className="open-young-chores__applied-filters">
                {filterDateLabel}
                {filterStatusLabel}
                {clearAllFilters}
            </div>
        );
    }

    loadChoreList(openYoungCardChores) {
        const listTitle = formatText('openYoungChoresList-listTitle');
        const { expandedRowId } = this.state;
        let choreList;
        const tableHeaders = ['date', 'task', 'status', 'amount'];
        const tableHeaderElements = tableHeaders.map((header,index) => (
            <OKTableCell className={`open-young-chores__header-cell--${header}`} asHeader={true} key={index}>
                <FormattedText format="uppercase" value={`openYoungChoresList-${header}`} />
            </OKTableCell>
        ));
        if(openYoungCardChores.get('getChoreListFetch')) {
            choreList = (
                <LoadingSection />
            );
        }else if(openYoungCardChores.get('getChoreListError')) {
            const retryButton = (
                <OKButton onClick={this.handleRetry}>
                    <FormattedText value="openYoungChores-retry" />
                </OKButton>
            );

            choreList = (
                <EmptyState
                    primaryText={formatText('openYoungChores-apiFailure')}
                    button={retryButton}
                    iconType="nointernet-banking" />
            );
        }else if(openYoungCardChores.get('byOrder').size === 0) {
            choreList = (
                <EmptyState
                    primaryText={formatText('openYoungChores-emptyList')}
                    iconType="search-banking" />
            );
        }else if(openYoungCardChores.get('byOrder').size > 0 && !isEmpty(openYoungCardChores.get('byId'))) {
            choreList = (
                <LastMovementsTable
                    groupByDate={true}
                    columnsCount={7}
                    id="chore-list-table"
                    rowComponent={ChoreListTableRow}
                    immTransactionsByOrder={openYoungCardChores.get('byOrder')}
                    immTransactionsById={openYoungCardChores.get('byId')}
                    expandedRowId={expandedRowId}
                    expandedRowComponent={ChoreListTableInfoRow}
                    onRowClick={this.handleRowClick}
                    currentMonthKey={LAST_MOVEMENTS_TABLE_CURRENT_MONTH_KEY}
                    language={language}
                >
                    <thead>
                        <OKTableRow asHeader={true}>
                            <OKTableCell
                                asHeader={true}
                                className="open-young-chores__header-cell open-young-chores__header-cell--toggler"
                            />
                            { tableHeaderElements }
                            <OKTableCell className="open-young-chores__header-cell--buttons" asHeader={true} />
                        </OKTableRow>
                    </thead>
                </LastMovementsTable>
            );
        }
        return (
            <article className="open-young-chores__content">
                <header>
                    <div className="open-young-chores__title">
                        <OKBoxTitle value={listTitle} />
                    </div>
                    <div className="open-young-chores__filters">
                        <OKButton modifier="task" onClick={this.handleToggleFilters}>
                            <i className="icon icon-filtrar open-young-chores__filter-settings-icon" />
                        </OKButton>
                    </div>
                    <div>
                        {this.displayAppliedFilters()}
                    </div>
                </header>
                <section>
                    {choreList}
                </section>
            </article>
        );
    }

    render() {
        const { match: { params: { cardId } }, immCards, openYoungCardChores } = this.props;
        const immCard = immCards.get('byId').get(cardId);
        let content;
        if (immCards.get('isFetching')) {
            content = <LoadingSection />;
        } else if (immCard) {
            const type = immCard.get('type');
            const subtitleLeft = formatText(`cards-${type}`);
            const subtitleRight = immCard.get('alias').get('current');
            const mappingBreadcrumb = [
                {
                    text: formatText('breadcrumb-cards'),
                    url: '/myprofile/cards'
                },
                {
                    text: immCard.get('alias').get('current'),
                    url: `/myprofile/cards/${cardId}/movements`
                },
                {
                    text: formatText('breadcrumb-openYoungChores')
                }
            ];
            const tutorial = (
                <TutorialLauncher
                    type={GRAPHIC_TUTOR_TYPE_4}
                    title={formatText('tutorials-openYoungChoresTitle')}
                />
            );

            content = (
                <div className="open-young-chores">
                    <div className="container-fluid">
                        <div className="row">
                            <OKCover size="medium" section="cards" customClass="col-xs-12">
                                <OKHeaderSubPage
                                    breadcrumbConfig={mappingBreadcrumb}
                                    tutorial={tutorial}
                                    finalTitle={getFinalTitle('openYoungChores-title')}
                                    subtitleLeft={subtitleLeft}
                                    subtitleRight={subtitleRight}
                                >
                                    <div className="open-young-chores__create-task-button">
                                        <OKButton onClick={this.handleCreateChore}>
                                            <FormattedText value="openYoungChores-createTask"/>
                                        </OKButton>
                                    </div>
                                </OKHeaderSubPage>
                            </OKCover>
                        </div>
                    </div>
                    <div className="grid-view__body">
                        <div className="container-fluid">
                            <div className="row grid-view--content-position-negative">
                                <div className="col-md-12">
                                    <OpenYoungCardChoresFilter
                                        isOpen={this.state.filterSettingsOpen}
                                        immFilters={openYoungCardChores.get('filters')}
                                        onCloseClick={this.handleToggleFilters}
                                        onFilterSubmitClick={this.handleSetFilter}
                                    />
                                    {this.loadChoreList(this.props.openYoungCardChores)}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        return content;
    }
}
OpenYoungCardChoresView.propTypes = {
    clearFilters: PropTypes.func.isRequired,
    getChoreList: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immCards: PropTypes.object.isRequired,
    openYoungCardChores: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    resetFilter: PropTypes.func.isRequired,
    setFilter: PropTypes.func.isRequired
};
module.exports.constructor = OpenYoungCardChoresView;
module.exports.OpenYoungCardChoresView = connect(
    state => ({
        immCards: state.cards,
        openYoungCardChores: state.openYoungCardChores
    }), {
        clearFilters: openYoungCardChores.clearOpenYoungCardChoresFilter,
        getChoreList: openYoungCardChores.getChoreList,
        resetFilter: openYoungCardChores.resetOpenYoungCardChoresFilter,
        setFilter: openYoungCardChores.setOpenYoungCardChoresFilter
    })(withRouter(OpenYoungCardChoresView));

